import moment, { Moment } from 'moment';

export function getDateRangeArray(dateStart?: any, dateEnd?: any, iterateBy: string = 'day') {
  dateStart = dateStart ? moment(dateStart) : moment();
  dateEnd = dateEnd ? moment(dateEnd) : moment();
  const dateValues = [];
  while (dateStart.isSameOrBefore(dateEnd)) {
    dateValues.push(dateStart.format('YYYY-MM-DD'));
    dateStart.add(1, iterateBy);
  }
  return dateValues;
}

export function formatTime(timeInMillis: number) {
  let result = '';
  let secs;

  if (timeInMillis) {
    secs = timeInMillis / 1000;
    const hours = secs / 3600;
    secs = secs % 3600;
    const mins = secs / 60;
    secs = secs % 60;

    if (hours >= 1) {
      result = `${Math.floor(hours)}h `;
      if (mins >= 1) {
        result += `${Math.floor(mins)}m`;
      }
    } else {
      if (mins >= 1) {
        result = `${Math.floor(mins)}m `;
      }
      if (secs >= 1) {
        result += `${Math.floor(secs)}s`;
      }
    }
  } else {
    result = '0s';
  }

  return result;
}

export function subtractMonth(curDate: any = moment(), numberOfMonth: number = 1) {
  return moment(curDate).subtract(numberOfMonth, 'month').format('YYYY-MM-DD');
}

export function addMonth(curDate: any = moment(), numberOfMonth: number = 1) {
  return moment(curDate).add(numberOfMonth, 'month').format('YYYY-MM-DD');
}

export function getWeekRangeByMonth(
  month: string | number | Moment = moment().format('MM'),
  year: string | number = moment().format('YYYY'),
  tillCurrentWeek: boolean = false) {
  month = moment(`${year}-${month}`, 'YYYY-MM');
  let startDate = moment(month).startOf('month');
  const endDate = moment(month).endOf('month');
  const startOfWeekInMonth = startDate.week();
  const endOfWeekInMonth = endDate.week();
  const endWeekNumber = tillCurrentWeek ? moment().week() : endOfWeekInMonth;
  const weekRangeByMonth = [];
  for (let week = startOfWeekInMonth; week <= endWeekNumber; week++) {
    weekRangeByMonth.push({
      week: startDate.week(),
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: startDate.endOf('week').isSameOrAfter(endDate) ?
        endDate.format('YYYY-MM-DD') : startDate.endOf('week').format('YYYY-MM-DD'),
    });
    startDate = startDate.endOf('week').add(1, 'day');
  }
  return weekRangeByMonth;
}

export function getHours(syncDate: string) {
  const hours = moment().diff(moment(syncDate), 'hours');
  return hours;
}
